import { IndirectTaxRegionHelper } from '../../common/helpers/IndirectTaxRegionHelper';
import { useIndirectTaxFilingAccess } from '../../common/hooks/useIndirectTaxFilingAccess';
import IndirectTaxFilingCalendarRedirect from '../components/IndirectTaxFilingCalendarRedirect';
import { IndirectTaxFilingCalendarDetailPage } from './IndirectTaxFilingCalendarDetailPage';
import {
  IndirectTaxFilingWorkflowDetailPage,
  type IndirectTaxFilingDetailPageProps,
} from './IndirectTaxFilingWorkflowDetailPage';

export const IndirectTaxFilingDetailPage = (
  props: IndirectTaxFilingDetailPageProps
) => {
  const { region, corporationId } = props;
  const { canViewDetails } = useIndirectTaxFilingAccess(region);
  if (!canViewDetails)
    return (
      <IndirectTaxFilingCalendarRedirect corporationId={corporationId} />
    );
  return IndirectTaxRegionHelper.isCalendarTrackingOnly(region) ? (
    <IndirectTaxFilingCalendarDetailPage {...props} />
  ) : (
    <IndirectTaxFilingWorkflowDetailPage {...props} />
  );
};
